import {ModalBody, ModalFooter} from "@chakra-ui/react";
import {FC} from "react";
import {Modal} from "./modal";
import {Button} from "@chakra-ui/button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  size?: 'sm' | 'md' | 'lg';
}

export const ModalWithFooter: FC<Props> = ({ isOpen, onClose, title, children, size }) => (
  <Modal isOpen={isOpen} onClose={onClose} title={title} size={size}>
    <ModalBody>{ children }</ModalBody>
    <ModalFooter>
      <Button onClick={onClose}>Close</Button>
    </ModalFooter>
  </Modal>
);
